import React, { useEffect, useState, useRef } from "react";
import clsx from "clsx";
import "swiper/css";
import "swiper/css/autoplay";
import { Collapse, makeStyles } from "@material-ui/core";
import { motion } from "framer-motion";

import SEO from "../../components/SEO";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import ClientScroll from "../../components/v4/clientScroll/ClientScroll";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";

import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";

import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";

import heroSectionImage from "../../images/v4/whatsappCatalogue/images/heroSectionImage.webp";
import whatIsAd from "../../images/v4/whatsappCatalogue/images/whatIsAd.webp";

import clientLogo1 from "../../images/v4/salesReps/clientLogo/transparentLogos/client1.png";
import clientLogo2 from "../../images/v4/salesReps/clientLogo/transparentLogos/client2.png";
import clientLogo3 from "../../images/v4/salesReps/clientLogo/transparentLogos/client3.png";
import clientLogo4 from "../../images/v4/salesReps/clientLogo/transparentLogos/client4.png";
import clientLogo5 from "../../images/v4/salesReps/clientLogo/transparentLogos/client5.png";
import clientLogo6 from "../../images/v4/salesReps/clientLogo/transparentLogos/client6.png";
import clientLogo7 from "../../images/v4/salesReps/clientLogo/transparentLogos/client7.png";

import benefitIcon1 from "../../images/v4/whatsappCatalogue/icons/benefitIcon1.svg";
import benefitIcon2 from "../../images/v4/whatsappCatalogue/icons/benefitIcon2.svg";
import benefitIcon3 from "../../images/v4/whatsappCatalogue/icons/benefitIcon3.svg";
import benefitIcon4 from "../../images/v4/whatsappCatalogue/icons/benefitIcon4.svg";
import benefitIcon5 from "../../images/v4/whatsappCatalogue/icons/benefitIcon5.svg";
import benefitIcon6 from "../../images/v4/whatsappCatalogue/icons/benefitIcon6.svg";

import experienceImg1 from "../../images/v4/whatsappCatalogue/images/exp1.webp";
import experienceImg2 from "../../images/v4/whatsappCatalogue/images/exp2.webp";
import experienceImg3 from "../../images/v4/whatsappCatalogue/images/exp3.webp";
import experienceImg4 from "../../images/v4/whatsappCatalogue/images/exp4.webp";
import experienceImg5 from "../../images/v4/whatsappCatalogue/images/exp5.webp";

import gradebg1 from "../../images/v4/whatsappAd/images/gradebg1.png";
import gradebg2 from "../../images/v4/whatsappAd/images/gradebg2.png";
import gradebg3 from "../../images/v4/whatsappAd/images/gradebg3.png";
import gradebg4 from "../../images/v4/whatsappAd/images/gradebg4.png";
import gradebg5 from "../../images/v4/whatsappAd/images/gradebg5.png";

import realWorldImage1 from "../../images/v4/whatsappCatalogue/images/realWorldImage1.webp";
import realWorldImage2 from "../../images/v4/whatsappCatalogue/images/realWorldImage2.webp";
import realWorldImage3 from "../../images/v4/whatsappCatalogue/images/realWorldImage3.webp";
import realWorldImage4 from "../../images/v4/whatsappCatalogue/images/realWorldImage4.webp";

import compareItemImg1 from "../../images/v4/whatsappCatalogue/images/compareItemImg1.webp";
import compareItemImg2 from "../../images/v4/whatsappCatalogue/images/compareItemImg2.webp";
import compareItemImg3 from "../../images/v4/whatsappCatalogue/images/compareItemImg3.webp";
import compareItemImg4 from "../../images/v4/whatsappCatalogue/images/compareItemImg4.webp";
import compareItemImg5 from "../../images/v4/whatsappCatalogue/images/compareItemImg5.webp";

import leadCaptureIcon from "../../images/v4/industryPage/leadCpature.png";
import quatationIcon from "../../images/v4/industryPage/quatation.png";
import contactManagemntIcon from "../../images/v4/industryPage/contactManagement.png";
import pipelineIcon from "../../images/v4/industryPage/pipeline.png";
import omniChannelIcon from "../../images/v4/industryPage/omnichannel.png";
import emailMarketingIcon from "../../images/v4/industryPage/emailmarketing.png";
import salesForecastIcon from "../../images/v4/industryPage/salesForecast.png";
import opportunityMangeIcon from "../../images/v4/industryPage/opportunityManagement.png";
import aiChatbotIcon from "../../images/v4/industryPage/aiChatbot.png";
import whatsappCrmIcon from "../../images/v4/industryPage/whatsappCrm.png";
import mobileCrmIcon from "../../images/v4/industryPage/mobileCrm.png";
import utmTrackingIcon from "../../images/v4/industryPage/utmTracking.png";
import realTimeDashboardIcon from "../../images/v4/industryPage/realTimeDashboard.png";
import voipToolIcon from "../../images/v4/industryPage/voipTool.png";
import videoConferencingIcon from "../../images/v4/industryPage/videoConference.png";

import salesdevpageHerobg from "../../images/v4/TgPages/salesDevReps/saleslogobg.png";

import bannerTick from "../../images/v4/salesReps/heroTick.svg";

import benefitSectionBg from "../../images/v4/whatsappAd/images/benefitSectionBg.png";
import heroSectionBg from "../../images/v4/whatsappCatalogue/images/heroSectionBg.png";
import topIndustiesBg from "../../images/v4/whatsappAd/images/topIndustiesBg.png";
import whatIsBg from "../../images/v4/whatsappAd/images/whatIsBg.png";
import accordianTabsBg from "../../images/v4/whatsappAd/images/accordianTabsBg.png";
import useCaseBg from "../../images/v4/whatsappAd/images/useCaseBg.png";

const useStyles = makeStyles((theme) => ({
  whatsappSection: {
    backgroundImage: `url(${heroSectionBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    paddingTop: "80px",
    "& $aiSectionLeft": {
      width: "50%",
      gap: "32px",
    },
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      marginTop: "70px",
    },
    "@media only screen and (max-width: 600px)": {
      "& $aiSectionLeft": {
        width: "100%",
        gap: "24px",
      },
      paddingTop: "0px",
      "& .centerContainer": {
        width: "100%",
        marginTop: "30px",
      },
      "& .container": {
        paddingBottom: "40px",
      },
      "& .buttonContaienr": {
        "& .primaryButton": {
          width: "100%",
        },
      },
    },
  },
  aiSectionContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
    },
  },
  aiSectionLeft: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "40%",
    gap: "20px",
    "& .highlighterText": {
      background: "linear-gradient(90deg, #7AFFAB 0%, #80C8FF 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  aiSectionRight: {
    width: "45%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  listContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "24px",
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    color: "#A2BED3",
  },
  integrationLeft: {
    width: "42%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  integrationRight: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "50%",
    gap: "20px",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benefitSection: {
    backgroundImage: `url(${whatIsBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "& $integrationLeft": {
      width: "45%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "10px",
    },
    "& $integrationHeader": {
      justifyContent: "space-around",
      alignItems: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& $integrationHeader": {
        flexDirection: "column-reverse",
      },
      "& $integrationLeft": {
        width: "100%",
      },
      "& $integrationRight": {
        width: "100%",
      },
    },
  },
  benefitSection2: {
    backgroundImage: `url(${benefitSectionBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      "& h2": {
        width: "50%",
        textAlign: "left",
      },
      "& p": {
        textAlign: "left",
        width: "40%",
      },
      "@media only screen and (max-width: 600px)": {
        flexDirection: "column",
        gap: "16px",
        "& h2": {
          width: "100%",
          textAlign: "left",
        },
        "& p": {
          textAlign: "left",
          width: "100%",
        },
      },
    },
  },
  integrationRightImage: {
    "& img": {
      width: "100%",
    },
  },
  integrationHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "30px",
    },
  },
  benefitContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "24px",
    rowGap: "24px",
    margin: "60px 0",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "32px",
    },
  },
  benefitBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "24px",
    width: "32%",
    padding: "24px",
    borderRadius: "16px",
    transition: "0.3s ease",
    background: "transparent",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "12px",
      padding: "0",
    },
    // "&:hover": {
    //   transition: "0.3s ease",
    //   background: "linear-gradient(117deg, #F2E1FF 0.97%, #E9FFFF 100%)",
    //   "@media only screen and (max-width: 600px)": {
    //     "&:hover": {
    //       background: "transparent",
    //     },
    //   },
    // },
  },
  experienceContainer: {
    position: "relative",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      "@media only screen and (max-width: 1024px)": {
        width: "80%",
      },
      "@media only screen and (max-width: 768px)": {
        width: "90%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
  },
  experienceInnerContainer: {
    display: "flex",
    alignItems: "stretch",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "20px",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
      alignItems: "flex-start",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
    },
  },
  experienceContainerLeft: {
    width: "40%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "16px",
    "& .exp-desc": {
      marginBottom: "24px",
    },
    "& .view-more-link": {
      textDecoration: "underline",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      "& img": {
        display: "inline-block!important",
        width: "16px!important",
        height: "16px",
        marginTop: "3px!important",
        transition: "transform 0.5s ease",
      },
      "&:hover": {
        color: "#010F1D",
        "& img": {
          transform: "translateX(5px)",
        },
      },
    },
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
      gap: "20px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      gap: "24px",
      alignItems: "center",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginTop: "30px",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "18px",
    },
  },
  experienceContainerRight: {
    width: "60%",
    minHeight: "450px",

    "@media only screen and (max-width: 768px)": {
      display: "none",
    },
    "& .rightContent": {
      padding: "32px",
      gap: "46px",
      borderRadius: "16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      height: "100%",
      "& p": {
        color: "#fff",
      },
      "& img": {
        width: "100%",
      },
    },
  },
  faqHeading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
      gap: "10px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  collapseBody: {
    display: "none",
    margin: "0",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      display: "block",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
        padding: "16px",
        borderRadius: "16px",
        overflow: "hidden",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0  ",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },

  accordianTabs: {
    backgroundImage: `url(${accordianTabsBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    position: "relative",
    "& .headercenterContainer": {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      marginBottom: "64px",
      flexDirection: "column",
      gap: "32px",
      width: "100%",
      "& h2": {
        width: "60%",
      },
      "& p": {
        width: "50%",
      },
      "@media only screen and (max-width: 768px)": {
        flexDirection: "column",
        gap: "24px",
        "& h2": {
          width: "100%",
          textAlign: "center",
        },
        "& p": {
          width: "100%",
          textAlign: "center",
        },
      },
    },
  },
  experienceHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    flexDirection: "column",
    "@media(max-width:768px)": {
      "& p": {
        display: "none",
      },
    },
  },
  faqBoxAccordian: {
    padding: "16px 24px",
    background: "#fff",
    borderRadius: "16px",
    position: "relative",
    transition: "all 0.3s ease",
    overflow: "hidden",
    width: "100%",
    "&:after": {
      content: '""',
      position: "absolute",
      left: "0",
      top: "0",
      width: "100%",
      height: "1px",
      background: "rgb(255, 255, 255)",
    },
    "&:before": {
      content: '""',
      position: "absolute",
      background: "#B1DBFF",
      background:
        "linear-gradient(90deg,rgba(32, 142, 236, 1) 25%, rgba(158, 90, 213, 1) 54%, rgba(255, 255, 255, 1) 80%)",
      left: "-16px",
      borderRadius: "16px",
      top: "0",
      width: "100%",
      height: "2px",
      transform: "scaleX(0) scaleY(1)",
      transformOrigin: "left",
      zIndex: 1,
    },
    "&.active": {
      background: "linear-gradient(270deg, #F8FCFF 0%, #E0EFFD 100%)",
      "&:before": {
        animation: "growTimerY 10s linear forwards", // Same as JS interval
      },
    },
    "& .body": {
      margin: "0",
    },
    "& .exp-desc": {
      margin: "10px 0 16px",
      whiteSpace: "nowrap",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      "@media(max-width:768px)": {
        whiteSpace: "normal",
        overflow: "visible",
        textAlign: "left",
        textOverflow: "unset",
      },
    },
  },
  combineSection: {
    position: "relative",
    paddingTop: "64px",
    backgroundImage: `url(${salesdevpageHerobg})`,
    backgroundSize: "cover",
    paddingBottom: "220px",
    "@media(max-width:600px)": {
      paddingBottom: "90px",
    },
  },
  integrationContent: {
    width: "100%",
    textAlign: "center",
    color: "#fff",
    maxWidth: "1200px",
    margin: "0 auto 32px",

    "& h2": {
      marginBottom: "16px !important",
      marginTop: "0 !important",
    },
    "& p": {
      marginBottom: "16px",
      textAlign: "left",
      paddingRight: "80px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& p": {
        paddingRight: "40px",
        fontSize: "18px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& p": {
        paddingRight: "0",
        textAlign: "center",
        fontSize: "16px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginBottom: "20px",
      "& p": {
        fontSize: "14px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& p": {
        fontSize: "13px",
      },
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "100%",
    transform: "translate(-50% ,-50%)",
    left: "50%",
    right: "0",
  },
  realWorldTabs: {
    backgroundImage: `url(${useCaseBg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingTop: "300px",
    "& h2": {
      textAlign: "center",
    },
    "& .container": {
      padding: "0 0 120px",
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "250px",
      "& .container": {
        padding: "0 24px 65px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "280px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "150px",
      "& .container": {
        padding: "40px 15px !important",
      },
    },

    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      textAlign: "center",
      "& h2": {
        width: "80%",
      },
    },
    "@media only screen and (max-width: 1200px)": {
      "& .centerContainer": {
        "& h2": {
          width: "100% !important",
        },
      },
    },
  },
  tabsContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    overflow: "auto",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "5px",
    },
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  tab: {
    width: "33%",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px",
    },
  },
  tabCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: "32px",
    gap: "40px",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
    },
  },
  tabCardLeftContainer: {
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    alignItems: "flex-start",
    "@media only screen and (max-width: 768px)": {
      alignItems: "center",
      width: "100%",
    },
  },
  benfitListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  benfitListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  benfitListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitIcon: {
    width: "24px!important",
    "& img": {
      width: "100%",
      marginTop: "6px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "24px!important",
    },
  },

  commonPageFooterSection: {
    background:
      "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 1024px)": {
      "& .centerContainer": {
        width: "90%",
        gap: "28px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& .centerContainer": {
        width: "95%",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& .centerContainer": {
        gap: "16px",
      },
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 1024px)": {
      width: "35%",
      top: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "12px 16px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "10px 14px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "8px 12px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "6px 10px",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 1024px)": {
      width: "65%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
    "@media only screen and (max-width: 1024px)": {
      marginBottom: "50px",
      gap: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "40px",
      gap: "16px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "30px",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      marginBottom: "25px",
      gap: "12px",
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "12px",
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      marginTop: "15px",
    },
  },
  topFiveHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  testimonials: {
    background: "#e9f4fe",
    paddingBottom: "50px",
    "@media(max-width:1025px)": {
      paddingBottom: "24px",
    },
  },
  commonPageFooterSection: {
    background:
      " linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  wpFaq: {
    // paddingTop: "120px",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
}));

const BestWhatsappBusinessCatalogueForSales = () => {
  const classes = useStyles();
  const AUTO_PLAY_INTERVAL = 10000;
  const sectionRef = useRef(null);
  const timeoutRef = useRef(null);
  const isInViewRef = useRef(false); //
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const [activeCompare, setActiveCompare] = useState("#section0");
  const clientScrollData = {
    title: "Trusted by top brands across industries",
    backgroundImage: "",
    logos: [
      {
        img: clientLogo1,
      },
      {
        img: clientLogo2,
      },
      {
        img: clientLogo3,
      },
      {
        img: clientLogo4,
      },
      {
        img: clientLogo5,
      },
      {
        img: clientLogo6,
      },
      {
        img: clientLogo7,
      },
    ],
    directions: ["left", "right", "left"],
    speeds: [0.8, 0.4, 0.8],
  };
  const benefits = [
    {
      title: "Unparalleled market reach",
      desc: "Tap into WhatsApp’s 3 billion users and connect with potential customers instantly, without relying on paid ads.",
      icon: benefitIcon1,
    },
    {
      title: "Enhanced customer experience",
      desc: "Let customers browse your catalog, ask questions, and place orders—all within the WhatsApp chat they already use.",
      icon: benefitIcon2,
    },
    {
      title: "Increased customer engagement",
      desc: "Display your offerings with high-quality images and detailed descriptions that invite exploration and boost interest.",
      icon: benefitIcon3,
    },
    {
      title: "Streamlined sales process",
      desc: "Eliminate platform-switching—guide customers from discovery to purchase directly within WhatsApp.",
      icon: benefitIcon4,
    },
    {
      title: "Real-time catalog management",
      desc: "Easily add, edit, or remove products to keep your catalog up-to-date and relevant at all times.",
      icon: benefitIcon5,
    },
    {
      title: "24/7 Availability",
      desc: "Your catalog is always live, allowing customers to browse and buy anytime—even outside business hours.",
      icon: benefitIcon6,
    },
  ];
  const experienceList = [
    {
      title: "Display product catalog within chat",
      alt: "WhatsApp business catalog featured item.",
      img: experienceImg1,
      bgImg: gradebg1,
      desc: "Empower your business by showcasing your product catalog within WhatsApp chats. Enable customers to explore your offerings without leaving the conversation. Increase product visibility, improve user engagement, and accelerate sales process.",
    },
    {
      title: "Manage WhatsApp catalogs easily",
      alt: "Sample item image in WhatsApp catalog.",
      img: experienceImg2,
      bgImg: gradebg2,
      desc: "Manage single-product and multi-product catalogs from within CRM. Enable your team to showcase your products and services on WhatsApp, engage in real-time conversations, track customer interactions, and drive conversion instantly.",
    },
    {
      title: "Sell instantly with catalogs",
      alt: "WhatsApp catalog with high-quality image.",
      img: experienceImg3,
      bgImg: gradebg3,
      desc: "Let customers seamlessly browse product listings, view images and prices, and add items to their cart—right within WhatsApp. With the best WhatsApp CRM, you can reduce friction, enhance convenience, and enable instant purchases on WhatsApp.",
    },
    {
      title: "Automated notifications",
      alt: "Square product photo WhatsApp catalog.",
      img: experienceImg3,
      bgImg: gradebg4,
      desc: "Set up smart triggers and auto-send WhatsApp notifications when customers purchase a product from your catalog. Automatically send order confirmation and order tracking to keep your customers engaged. Stay ahead by cross-selling to customers.",
    },
    {
      title: "All-in-one WhatsApp CRM",
      alt: "WhatsApp business catalog 640x640 image.",
      img: experienceImg5,
      bgImg: gradebg5,
      desc: "Pepper Cloud works hand-in-hand with your tech stack for effective sales pipeline tracking, marketing automation, and customer support. This unified system enhances collaboration, accelerates conversions, and simplifies overall business operations.",
    },
  ];
  // Clear timeout
  const clearTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  // Schedule next change
  const scheduleNext = () => {
    clearTimer();
    if (!isInViewRef.current) return; // only autoplay if section is visible

    timeoutRef.current = setTimeout(() => {
      setActiveAccordian((prev) => (prev + 1) % experienceList.length);
    }, AUTO_PLAY_INTERVAL);
  };

  // Start/pause autoplay based on scroll visibility
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          isInViewRef.current = true;
          scheduleNext(); // resume autoplay
        } else {
          isInViewRef.current = false;
          clearTimer(); // pause autoplay
        }
      },
      { threshold: 0.3 } // section is considered "in view" when 30% visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      observer.disconnect();
      clearTimer();
    };
  }, [experienceList.length]);

  // Reschedule on activeAccordian change
  useEffect(() => {
    scheduleNext();
    return () => clearTimer();
  }, [activeAccordian, experienceList.length]);

  // Handle user click
  const handleAccordionClick = (index) => {
    setActiveAccordian(index);
    // scheduleNext will run via useEffect so this stays open full interval
  };

  const allIcons = [
    {
      img: leadCaptureIcon,
      title: "Auto lead capture",
    },
    {
      img: contactManagemntIcon,
      title: "Contact management",
    },
    {
      img: pipelineIcon,
      title: "Pipeline management",
    },
    {
      img: omniChannelIcon,
      title: "Omnichannel CRM",
    },
    {
      img: emailMarketingIcon,
      title: "Email marketing",
    },
    {
      img: quatationIcon,
      title: "Quotation generation",
    },
    {
      img: salesForecastIcon,
      title: "Sales forecasting",
    },
    {
      img: opportunityMangeIcon,
      title: "Opportunity management",
    },
    {
      img: aiChatbotIcon,
      title: "AI chatbot",
    },
    {
      img: whatsappCrmIcon,
      title: "WhatsApp CRM",
    },
    {
      img: mobileCrmIcon,
      title: "Mobile CRM",
    },
    {
      img: utmTrackingIcon,
      title: "UTM tracking",
    },
    {
      img: realTimeDashboardIcon,
      title: "Real-time dashboard",
    },
    {
      img: voipToolIcon,
      title: "VOIP tool integration",
    },
    {
      img: videoConferencingIcon,
      title: "Video conferencing",
    },
  ];

  // Function to distribute icons across three tracks
  function distributeIcons(icons) {
    // Sort icons alphabetically to ensure consistent distribution
    const sortedIcons = [...icons].sort((a, b) =>
      a.title.localeCompare(b.title)
    );

    const logotrack1 = [];
    const logotrack2 = [];

    sortedIcons.forEach((icon, index) => {
      // Distribute icons based on their index
      switch (index % 2) {
        case 0:
          logotrack1.push(icon);
          break;
        case 1:
          logotrack2.push(icon);
          break;
      }
    });

    return {
      logotrack1,
      logotrack2,
    };
  }

  // Get the distributed icons
  const { logotrack1, logotrack2 } = distributeIcons(allIcons);

  useEffect(() => {
    // Infinite scroll functionality

    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".logos-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "left";
        this.init();
      }

      init() {
        // Clone the track content
        const content = this.track.innerHTML;
        this.track.innerHTML = content + content + content;

        // Calculate total width
        const logos = this.track.querySelectorAll(".logo");
        let totalWidth = 0;
        logos.forEach((logo) => {
          totalWidth +=
            logo.offsetWidth +
            parseInt(getComputedStyle(logo).marginLeft) +
            parseInt(getComputedStyle(logo).marginRight);
        });

        // Set row height
        this.row.style.height = logos[0].offsetHeight + 20 + "px";

        // Set initial position for right-to-left movement
        if (this.direction === "left") {
          this.position = 0;
        } else {
          this.position = -this.track.offsetWidth / 3;
        }

        // Start animation
        this.animate();
      }

      animate() {
        const animate = () => {
          // Update position based on direction
          if (this.direction === "left") {
            this.position -= this.speed;
            // Reset position when one-third of content has scrolled
            const oneThirdWidth = -this.track.offsetWidth / 3;
            if (this.position <= oneThirdWidth) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            // Reset position when one-third of content has scrolled
            if (this.position >= 0) {
              this.position = -this.track.offsetWidth / 3;
            }
          }

          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
      }
    }

    // Initialize all rows with different speeds and directions
    document.querySelectorAll(".logos-row").forEach((row) => {
      const speed = parseFloat(row.dataset.speed) || 1;
      new InfiniteScroll(row, speed);
    });
  }, []);

  const tabContentData = [
    {
      tabContent: [
        {
          heading: "Abandoned cart recovery",
          content:
            "Send timely reminders with special offers to encourage customers to complete their purchases.",
          alt: "Abandoned cart recovery",
        },
        {
          heading: "Product launch updates",
          content:
            "Notify customers instantly about new arrivals, trending products, and exclusive deals.",
          alt: "Product launch updates",
        },
        {
          heading: "Order tracking",
          content:
            "Keep customers informed with real-time order status updates and delivery notifications.",
          alt: "Order tracking",
        },
        {
          heading: "Catalog sharing",
          content:
            "Share product catalog links to highlight trending collections and seasonal promotions.",
          alt: "Catalog sharing",
        },
      ],
      image: realWorldImage1,
      alt: "WhatsApp business catalog product display.",
      subtitle:
        "Boost sales and customer loyalty with targeted promotions and personalised recommendations.",
    },
    {
      tabContent: [
        {
          heading: "Easy menu sharing",
          content:
            "Share digital menus and combo offers through WhatsApp Catalog with optimised image sizes for better visibility.",
          alt: "Easy menu sharing",
        },
        {
          heading: "Visual promotions",
          content:
            "Highlight daily specials, limited-time offers, or festive meal packs using rich visuals to attract attention.",
          alt: "Visual promotions",
        },
        {
          heading: "Quick reorders",
          content:
            "Allow frequent customers to reorder their favourites easily through saved catalog items in chat.",
          alt: "Quick reorders",
        },
        {
          heading: "Live updates",
          content:
            "Instantly update item availability and pricing in real-time—no need to resend the menu manually.",
          alt: "Live updates",
        },
      ],
      image: realWorldImage2,
      alt: "WhatsApp catalog promotional item preview.",
      subtitle: "Simplify ordering with interactive digital menus.",
    },
    {
      tabContent: [
        {
          heading: "Service listing",
          content:
            "Showcase your services with images, pricing, and descriptions directly in the WhatsApp Business Catalog.",
          alt: "Service listing",
        },
        {
          heading: "In-chat booking",
          content:
            "Let customers explore and book services instantly through WhatsApp chat without switching platforms.",
          alt: "In-chat booking",
        },
        {
          heading: "Personalised offerings",
          content:
            "Share tailored service packages based on previous conversations or customer preferences.",
          alt: "Personalised offerings",
        },
        {
          heading: "Real-time updates",
          content:
            "Instantly update services to reflect availability, special offers, or limited-time promotions.",
          alt: "Real-time updates",
        },
      ],
      image: realWorldImage3,
      alt: "Preview of WhatsApp catalog collection.",
      subtitle:
        "Enhance service discovery and appointment bookings through WhatsApp.",
    },
    {
      tabContent: [
        {
          heading: "Detailed product catalogs",
          content:
            "Present comprehensive catalogs with pricing tiers, MOQ (minimum order quantity), and product specifications tailored for wholesale and B2B buyers.",
          alt: "Detailed product catalogs",
        },
        {
          heading: "Curated sales lists",
          content:
            "Share personalised or industry-specific product lists during sales conversations to drive quicker decision-making.",
          alt: "Curated sales lists",
        },
        {
          heading: "Live inventory updates",
          content:
            "Keep your WhatsApp catalog up to date with current stock levels, seasonal promotions, or limited-time deals for your distributors and buyers.",
          alt: "Live inventory updates",
        },
        {
          heading: "Lead engagement tracking",
          content:
            "Monitor catalog views and interactions, then follow up with high-potential leads directly via WhatsApp CRM.",
          alt: "Lead engagement tracking",
        },
      ],
      image: realWorldImage4,
      alt: "Product showcase in WhatsApp catalog.",
      subtitle:
        "Streamline product distribution and customer engagement for wholesale buyers.",
    },
  ];
  const compareItems = [
    "Pepper Cloud CRM",
    "360Dialog",
    "Wati",
    "Rasayel",
    "Engati",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud CRM stands out as the ideal solution for managing your WhatsApp Business Catalog. With seamless integration, it simplifies catalog management, automates customer interactions, and streamlines your product promotions.",
      img: compareItemImg1,
      alt: "Pepper Cloud CRM",
      features: [
        {
          title: "Seamless WhatsApp integration",
          desc: "Direct integration with WhatsApp ensures smooth catalog management.",
        },
        {
          title: "Multi-channel communication",
          desc: "Manage conversations across WhatsApp, email, and more.",
        },
        {
          title: "Customer interaction insights",
          desc: "Access real-time data on customer engagement.",
        },
        {
          title: "Workflow automation",
          desc: "Streamline follow-ups, catalog sharing, and order processes.",
        },
        {
          title: "Easy product updates",
          desc: "Quickly update product details and prices.",
        },
        {
          title: "Personalised promotions",
          desc: "Send tailored offers via WhatsApp.",
        },
        {
          title: "Secure data management",
          desc: "Protect your catalog and customer data.",
        },
        {
          title: "Scalable for growth",
          desc: "Perfect for small and growing businesses.",
        },
      ],
    },
    {
      title: "360Dialog",
      desc: "360Dialog is a WhatsApp API provider offering basic catalog management through direct integration but lacks robust CRM features.",
      img: compareItemImg2,
      alt: "360Dialog",
      features: [
        {
          title: "Direct integration with WhatsApp API",
          desc: "Supports direct integration with the WhatsApp Business API for managing catalogs and sending product information.",
        },
        {
          title: "Catalog sharing capability",
          desc: "Allows businesses to send WhatsApp Business Catalogs directly to customers for easy browsing and product discovery.",
        },
        {
          title: "Limited CRM functionality",
          desc: "Lacks a full-fledged CRM system; requires integration with third-party CRMs to access advanced customer management features.",
        },
        {
          title: "Basic analytics and reporting",
          desc: "Provides basic analytics and reporting features for tracking customer interactions, message performance, and engagement.",
        },
      ],
    },
    {
      title: "Wati",
      desc: "Wati is a platform focused on communication and team collaboration, built mainly around WhatsApp.",
      img: compareItemImg3,
      alt: "Wati",
      features: [
        {
          title: "Focus on team collaboration and communication",
          desc: "Strong emphasis on enhancing team collaboration and managing customer communication effectively through WhatsApp.",
        },
        {
          title: "Limited catalog and automation features",
          desc: "Offers minimal catalog management and limited automation, which may not suffice for businesses with complex product needs.",
        },
        {
          title: "No advanced CRM functionality",
          desc: "Does not include advanced CRM features for tracking sales pipelines, customer journeys, or detailed marketing analytics.",
        },
        {
          title: "Simplified UI for small businesses",
          desc: "User interface is designed to be simple and user-friendly, making it suitable for small businesses but less scalable for larger operations.",
        },
      ],
    },
    {
      title: "Rasayel",
      desc: "Rasayel offers a simple WhatsApp solution with WhatsApp Business catalog integration.",
      img: compareItemImg4, // NOTE: Update this if a different image is available for Rasayel
      alt: "Rasayel",
      features: [
        {
          title: "Built for customer support teams",
          desc: "Specifically designed to support customer service operations using WhatsApp communication tools.",
        },
        {
          title: "Lacks catalog management functionality",
          desc: "Does not offer direct support for managing or sending WhatsApp Business Catalogs.",
        },
        {
          title: "Limited automation capabilities",
          desc: "Provides minimal automation for catalog sharing and engaging with customers at scale.",
        },
        {
          title: "Basic reporting and insights",
          desc: "Offers only basic reporting features and limited data insights on customer interactions and performance.",
        },
      ],
    },
    {
      title: "Engati",
      desc: "Primarily a chatbot platform, Engati has limited catalog management tools, focussing more on customer service automation.",
      img: compareItemImg5, // NOTE: Update this if a different image is available for Engati
      alt: "Engati",
      features: [
        {
          title: "Chatbot-centric platform with WhatsApp integration",
          desc: "Primarily designed around chatbot functionality, offering WhatsApp integration for automated customer communication.",
        },
        {
          title: "Minimal catalog management",
          desc: "Offers limited support for catalog management, with a primary focus on automating customer service rather than showcasing products.",
        },
        {
          title: "Lacks robust CRM features",
          desc: "Does not provide comprehensive CRM tools for managing sales pipelines, product listings, or customer lifecycle tracking.",
        },
        {
          title: "Strong chatbot capabilities, limited sales utility",
          desc: "Excels in handling customer queries through chatbots but falls short when it comes to driving product discovery and sales.",
        },
      ],
    },
  ];
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const faqs = [
    {
      question:
        "How many products can I include in my WhatsApp Business Catalog?",
      answer: (
        <>
          There is no strict limit, but it is best to keep your catalog
          manageable and relevant to your customers.
        </>
      ),
    },
    {
      question: "Can I send my entire catalog to customers?",
      answer: (
        <>
          Yes, you can send your entire catalog or select specific products to
          share with customers.
        </>
      ),
    },
    {
      question: "Is there a charge for sending catalogs through WhatsApp?",
      answer: <>No, sending catalogs does not incur any additional charges.</>,
    },
    {
      question:
        "Can I use the same catalog with multiple WhatsApp business numbers?",
      answer: (
        <>
          No, a catalog can only be connected to one WhatsApp number at a time.
        </>
      ),
    },
    {
      question: "How often should I update my WhatsApp Business Catalog?",
      answer: (
        <>
          It is best to update your catalog regularly, especially when adding
          new products, changing prices, or updating availability.
        </>
      ),
    },
    {
      question:
        "Can customers purchase directly through the WhatsApp Business Catalog?",
      answer: (
        <>
          While customers cannot complete purchases directly through the
          catalog, they can easily place orders based on the information
          provided.
        </>
      ),
    },
    {
      question:
        "How can Pepper Cloud CRM help me manage my WhatsApp Business Catalog?",
      answer: (
        <>
          Pepper Cloud CRM provides tools for easy catalog connection,
          management, and analysis, streamlining your WhatsApp business
          operations.
        </>
      ),
    },
    {
      question: "Can I track the performance of my WhatsApp Business Catalog?",
      answer: (
        <>
          Yes, with Pepper Cloud CRM, you can analyse catalog performance and
          customer engagement to optimise your strategy.
        </>
      ),
    },
    {
      question:
        "What are the best practices for using WhatsApp Business Catalog effectively?",
      answer: (
        <>
          <div>
            <strong>Do's:</strong>
            <ul>
              <li>
                Keep your catalog up-to-date with accurate product details
              </li>
              <li>
                Use high-quality images that clearly showcase your products
              </li>
              <li>
                Organise products into well-defined categories for easy browsing
              </li>
              <li>
                Respond promptly to customer enquiries about catalog items
              </li>
              <li>
                Regularly analyse catalog performance and adjust listings
                accordingly
              </li>
            </ul>
            <strong>Don'ts:</strong>
            <ul>
              <li>
                Don’t send too many products in a single message—keep it focused
              </li>
              <li>Don’t use low-quality or misleading product images</li>
              <li>Don’t forget to update pricing and availability regularly</li>
              <li>Don’t send catalogs outside the 24-hour messaging window</li>
              <li>Don’t ignore valuable customer feedback on catalog items</li>
            </ul>
          </div>
        </>
      ),
    },
    {
      question:
        "How do I choose the best software for managing a WhatsApp Business Catalog for my small business?",
      answer: (
        <>
          When selecting software for WhatsApp Business Catalog management,
          consider the following factors:
          <ul>
            <li>
              <strong>Integration with WhatsApp Business:</strong> Ensure the
              tool works seamlessly with WhatsApp for smooth catalog updates and
              messaging.
            </li>
            <li>
              <strong>Ease of use:</strong> Choose a platform with a simple
              interface to easily add, update, and organize product details.
            </li>
            <li>
              <strong>Automation capabilities:</strong> Look for features that
              automate catalog sharing, customer communication, and order
              handling.
            </li>
            <li>
              <strong>CRM features:</strong> Prefer software that also offers
              customer relationship management to track and personalise
              interactions.
            </li>
            <li>
              <strong>Scalability:</strong> Select a solution that can grow with
              your business and handle larger product lists and customer bases.
            </li>
            <li>
              <strong>Cost efficiency:</strong> Balance features with
              affordability to find a solution that fits your budget.
            </li>
            <li>
              <strong>Analytics and insights:</strong> Opt for tools with
              built-in reporting to track engagement, performance, and sales.
            </li>
          </ul>
        </>
      ),
    },
  ];

  return (
    <main>
      <SEO
        title={"Best WhatsApp Business Product Catalogue | Pepper Cloud"}
        pathname={
          "https://peppercloud.com//whatsapp-crm-feature/free-whatsapp-link-generator/"
        }
        keywords="WhatsApp Business catalog, whatsapp catalog, whatsapp business catalog image size, whatsapp business catalog"
        description={
          "Give 24X7 real-time constant customer support and experience 3X ROI using AI Driven WhatsApp Chatbot. Offers features like multiple device support, bulk messaging, and more."
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Pepper Cloud",
          legalName: "Pepper Cloud PTE LTD",
          url: "https://peppercloud.com/",
          logo: "https://peppercloud.com/icons/logo.png",
          foundingDate: "2017",
          address: [
            {
              "@type": "PostalAddress",
              streetAddress: "#04-01/02",
              addressLocality: "Blk 79 Ayer Rajah Crescent",
              addressRegion: "SG",
              postalCode: "139955",
              addressCountry: "Singapore",
            },
            {
              "@type": "PostalAddress",
              streetAddress:
                "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
              addressLocality: "Bengaluru",
              addressRegion: "KA",
              postalCode: "560095",
              addressCountry: "India",
            },
          ],
          contactPoint: {
            "@type": "ContactPoint",
            contactType: "customer support",
            telephone: "+6566562616",
            email: ["sales@peppercloud.com", "support@peppercloud.com"],
          },
          sameAs: [
            "https://twitter.com/peppercloudpte",
            "https://www.linkedin.com/company/peppercloud/",
            "https://www.facebook.com/PepperCloudPteLtd",
            "https://www.instagram.com/pepper.cloud/",
          ],
        }}
      />
      <section className={classes.whatsappSection}>
        <div className="container">
          <div className={classes.aiSectionContainer}>
            <div className={classes.aiSectionLeft}>
              <motion.h1
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-semibold font-64 font-white"
              >
                Boost sales with WhatsApp Business Catalog
              </motion.h1>
              <motion.p
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-regular font-18 font-white"
              >
                Showcase your products with ease using WhatsApp Business
                Catalogs in WhatsApp CRM. Share catalog links, simplify
                browsing, and manage orders directly on WhatsApp for a smoother
                sales experience.
              </motion.p>
              <div className={classes.listContainer}>
                <div className={classes.listItem}>
                  <LazyImage
                    source={greenCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-wix-regular font-18 font-white">
                    Instantly share product catalogs via chat or broadcast.
                  </p>
                </div>
                <div className={classes.listItem}>
                  <LazyImage
                    source={greenCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-wix-regular font-18 font-white">
                    Manage enquiries, orders, and updates in WhatsApp.
                  </p>
                </div>
                <div className={classes.listItem}>
                  <LazyImage
                    source={greenCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-wix-regular font-18 font-white">
                    Automate follow-ups and product suggestions easily.
                  </p>
                </div>
              </div>
              <div className="buttonContaienr">
                <Link
                  className="primaryButton font-16 font-wix-medium font-white"
                  to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
                >
                  Book a free demo
                </Link>
              </div>
            </div>
            <motion.div
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className={classes.aiSectionRight}
            >
              <LazyImage
                source={heroSectionImage}
                width={"100%"}
                alt="Crisp catalog product image WhatsApp."
              />
            </motion.div>
          </div>
        </div>
      </section>
      <ClientScroll
        {...clientScrollData}
        background={topIndustiesBg}
        darkLayout={true}
      />
      <section className={clsx(classes.benefitSection)}>
        <div className="container">
          <div className={classes.integrationHeader}>
            <div className={classes.integrationRight}>
              <LazyImage
                source={whatIsAd}
                alt="WhatsApp catalog visual presentation example."
                className={classes.integrationRightImage}
              />
            </div>
            <div className={classes.integrationLeft}>
              <motion.div
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="sectionTag"
              ></motion.div>
              <motion.h2
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-semibold font-56 color-black1"
              >
                What is WhatsApp Business Catalog?
              </motion.h2>
              <motion.p
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-regular font-18 color-black2 mt20"
              >
                WhatsApp Business Catalog is a feature embedded within the
                business version of the popular messaging platform. It allows
                businesses like yours to create a digital showcase of your
                products or services, complete with images, descriptions, and
                prices. This virtual catalog can be accessed by your customers
                across mobile, web, and desktop interfaces, providing a
                convenient shopping experience directly within WhatsApp.
              </motion.p>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.benefitSection2}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              Benefits of WhatsApp Catalog for business
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-regular font-18 font-white"
            >
              Using WhatsApp Business Catalog gives your business a competitive
              edge by making product discovery, engagement, and purchase
              seamless—right within a platform your customers already use daily.
            </motion.p>
          </div>
          <div className={classes.benefitContainer}>
            {benefits.map((benefit) => (
              <div className={classes.benefitBox}>
                <img
                  src={benefit.icon}
                  alt="Customer support automation tool"
                />
                <p className="font-wix-semibold font-24 font-white">
                  {benefit.title}
                </p>
                <p className="font-wix-regular font-18 font-white">
                  {benefit.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className={classes.accordianTabs}>
        <div className="container">
          <div className="headercenterContainer">
            <motion.h2
              className="font-wix-semibold font-56 text-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Pepper Cloud: Drive sales with WhatsApp catalog
            </motion.h2>
            <p className="font-18 font-wix-regular text-black2">
              Pepper Cloud makes catalog management smarter and faster with
              seamless WhatsApp integration and powerful CRM features.
            </p>
          </div>
          <div className={classes.experienceInnerContainer}>
            <div className={classes.experienceContainerLeft} ref={sectionRef}>
              {experienceList.map((faq, index) => (
                <motion.div
                  className={clsx(
                    classes.faqBoxAccordian,
                    index === activeAccordian && "active",
                    "text-color2"
                  )}
                  key={`faq-${index}`}
                  onClick={() => handleAccordionClick(index)}
                  transition={{ duration: 1, delay: index * 0.01 }}
                  whileInView={{ opacity: [0, 1], y: [50, 0] }}
                >
                  <div className={classes.experienceHeader}>
                    <h3 className="font-20 font-wix-semibold">{faq.title}</h3>
                    <p className="font-18 font-wix-regular color-black2 exp-desc">
                      {faq.desc}
                    </p>
                  </div>

                  <Collapse
                    className={classes.collapseBody}
                    in={activeAccordian === index}
                  >
                    <p className="font-18 font-wix-regular color-black2 exp-desc">
                      {faq.desc}
                    </p>
                    <motion.img
                      alt={faq.alt}
                      initial={{ opacity: 1, y: 20 }}
                      src={faq.img}
                      transition={{ duration: 0.3 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      style={{
                        backgroundImage: `url(${faq.bgImg})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    />
                  </Collapse>
                </motion.div>
              ))}
            </div>
            <div className={classes.experienceContainerRight}>
              {experienceList.map(
                (experience, index) =>
                  index === activeAccordian && (
                    <div
                      className="rightContent"
                      style={{
                        backgroundImage: `url(${experience.bgImg})`, // pass your image URL in experience.bgImage
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      <motion.img
                        src={experience.img}
                        initial={{ opacity: 0, x: 50 }} // start 50px left, invisible
                        whileInView={{ opacity: 1, x: 0 }} // animate to normal position
                        transition={{ duration: 0.6, ease: "easeOut" }}
                        viewport={{ once: true, amount: 0.2 }} // trigger when 20% visible, only once
                      />
                      <motion.p
                        className="font-18 font-wix-regular"
                        initial={{ opacity: 0, x: -50 }} // start 50px left, invisible
                        whileInView={{ opacity: 1, x: 0 }} // animate to normal position
                        transition={{ duration: 0.6, ease: "easeOut" }}
                        viewport={{ once: true, amount: 0.2 }} // trigger when 20% visible, only once
                      >
                        {experience.desc}
                      </motion.p>
                    </div>
                  )
              )}
            </div>
          </div>
        </div>
      </section>
      <section className={classes.combineSection}>
        <div className={classes.integrationContent}>
          <motion.h2
            className="font-wix-semibold font-56 color-white"
            initial={{ opacity: 1, y: 20 }}
            transition={{ duration: 0.3 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            Pepper Cloud CRM features tailored for business success
          </motion.h2>
        </div>

        <section className="sales-dev-logo-carousel">
          <div className="logos-container">
            <div className="scroll-container">
              <div className="logos-row" data-direction="left" data-speed="0.8">
                <div className="logos-track">
                  {logotrack1.map((logo) => (
                    <div
                      className="logo font-18 font-wix-medium"
                      key={logo.title}
                    >
                      <img alt={`${logo.title} integration`} src={logo.img} />
                      <p>{logo.title}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div
                className="logos-row"
                data-direction="right"
                data-speed="0.4"
              >
                <div className="logos-track">
                  {logotrack2.map((logo) => (
                    <div className="logo font-18 font-wix-medium">
                      <img alt={`${logo.title} integration`} src={logo.img} />
                      <p>{logo.title}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className={classes.absoulteCard}>
          <TruestedSection shadow background={true} />
        </div>
      </section>
      <section className={classes.realWorldTabs}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-semibold font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Applications and Use Cases of WhatsApp Business Catalog
            </motion.h2>
            <div className={classes.tabsContainer}>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 0 && "active"
                )}
                onClick={() => setActiveRealWorld(0)}
              >
                E-commerce
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 1 && "active"
                )}
                onClick={() => setActiveRealWorld(1)}
              >
                Food and Beverage
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 2 && "active"
                )}
                onClick={() => setActiveRealWorld(2)}
              >
                Service-Based Businesses
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 3 && "active"
                )}
                onClick={() => setActiveRealWorld(3)}
              >
                B2B and Wholesale
              </div>
            </div>
          </div>

          <div className={classes.tabCard}>
            <div className={classes.tabCardLeftContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <div>
                      <motion.p
                        className="font-wix-regular font-18 color-black2"
                        initial={{ opacity: 0, y: 20 }}
                        transition={{ duration: 0.3 }}
                        whileInView={{ opacity: 1, y: 0 }}
                      >
                        {listItem.subtitle}
                      </motion.p>
                      <div className={classes.benfitListContainer}>
                        {listItem.tabContent.map((item) => (
                          <motion.div
                            className={classes.benfitListItem}
                            initial={{ opacity: 0, y: 20 }}
                            transition={{ duration: 0.3 }}
                            whileInView={{ opacity: 1, y: 0 }}
                          >
                            <LazyImage
                              alt={item.alt}
                              className={classes.benfitIcon}
                              source={bannerTick}
                            />
                            <div className={classes.benfitListItemContent}>
                              <p className="font-wix-semibold font-20 color-black1">
                                {item.heading}
                              </p>
                              <p className="font-wix-regular font-18 color-black2">
                                {item.content}
                              </p>
                            </div>
                          </motion.div>
                        ))}
                      </div>
                    </div>
                  )
              )}
            </div>
            <div className={classes.tabCardRightContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <motion.div
                      initial={{ opacity: 1, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      // className={classes.aiSectionRight}
                    >
                      <LazyImage
                        alt={listItem.alt}
                        source={listItem.image}
                        width={"100%"}
                      />
                    </motion.div>
                  )
              )}
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-semibold font-56 font-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              5 Best software for WhatsApp Business Catalog in 2025
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` &&
                        "font-wix-semibold"
                    )}
                    href={`#section${index}`}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    className="font-40 font-wix-semibold font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.title}
                  </h3>
                  <p
                    className="font-wix-regular font-18 font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.desc}
                  </p>
                  <img alt={data.alt} className="productImage" src={data.img} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                      >
                        <div className={classes.topFiveHeader}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                            src={downArrow}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-wix-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <div className={classes.testimonials}>
        <TestimonialSlider
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
          heading={"Real stories. Real results."}
          noButton={true}
        />
      </div>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFF8F5"}
          faqs={faqs}
          heading={"WhatsApp catalog - Frequently asked questions (FAQs)"}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Turn conversations into sales instantly
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
            >
              Get started
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default BestWhatsappBusinessCatalogueForSales;
